import { Controller } from "@hotwired/stimulus"

export default class TurboFrameSrcController extends Controller {
  update() {
    const currentPathname = window.location.pathname
    this.element.src = currentPathname
  }

  reload() {
    this.element.reload()
  }

  refresh() {
    if (this.element.src) {
      this.element.reload()
    } else {
      this.element.src = window.location.href
    }
  }

  ignoreMissingFrame(event) {
    event.preventDefault()
  }
}
